module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.581b2fa2.png";